import { useTheme } from 'styled-components';
import useIntroController from '../../../1_application/intro/introController';
import LXLargeButton from '../../core/components/buttons/lxLargeButton';

const TestRequestButtons = () => {
  const theme = useTheme();
  const { redirectToClinic } = useIntroController();
  return (
    <LXLargeButton onClick={redirectToClinic}>
      {theme.intro.examinationRequest}
    </LXLargeButton>
  );
};

export default TestRequestButtons;
